module.exports = __webpack_public_path__ + "img/Kristallwelten.8596699e.jpg";